"use client";

/**
 * Свой перечень комментариев проктора для отдельных школ.
 *
 * Обычно проктор выбирает признаки из общего каталога danger-действий. Некоторым
 * заказчикам нужен свой короткий список — тогда сюда добавляется запись, и на
 * всех заданиях этой школы пикер показывает только её пункты.
 *
 * Ключ — «бренд:school_id»: идентификаторы школ живут в базе своего арендатора,
 * и школа №6 у русских не имеет отношения к школе №6 у нас.
 *
 * Значения — raw-ключи из LOCAL_DANGER_ACTIONS, чтобы подпись бралась из
 * переводов, а в сохранённом комментарии лежал обычный токен [TAG:key].
 */
import type { VerdictStatus } from "./types";

export interface SchoolVerdictPreset {
  /** Чем можно объяснить «Не честно» — весь список пикера для этого статуса. */
  dishonest: string[];
  /** Что подставляется само при «Честно» (проктору остаётся сохранить). */
  honest: string[];
}

const PRESETS: Record<string, SchoolVerdictPreset> = {
  // «Честный Экзамен», школа 6 — список согласован заказчиком 28.09.2026.
  "examru:6": {
    dishonest: ["local_outside_help", "local_cheating_attempt", "local_forbidden_tools"],
    honest: ["local_passed_independently"],
  },
};

export function getSchoolVerdictPreset(
  brandKey: string | null | undefined,
  schoolId: number | null | undefined,
): SchoolVerdictPreset | null {
  if (!brandKey || !schoolId) return null;
  return PRESETS[`${brandKey}:${schoolId}`] ?? null;
}

/** Пункты пикера для статуса: у «Честно» свой единственный вариант. */
export function presetActionsFor(
  preset: SchoolVerdictPreset | null,
  status: VerdictStatus | null,
): string[] | null {
  if (!preset || !status) return null;
  return status === "honest" ? preset.honest : preset.dishonest;
}
